/* this file added by Bearer Web Developer  */
import styles from './reservationSource.module.scss';
import { useAppState } from "../../../states/app-state";
import { useThemeMode } from '../../../states/contexts/theme';

const ReservationSource = () => {
    const appState = useAppState();
    const intermediate_api_platform = appState?.ReservedOrders.activeManageOrder?.intermediate_api_platform;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.reservation_source} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                theme === "dark" ? <img src="/language-white.svg" alt="" width={21} height={21} /> :
                    <img src="/language-black.webp" alt="" width={21} height={21} />
            }
            <div className={styles.text}>
                <h4>Reservation Source:</h4>
                <p>{intermediate_api_platform}</p>
            </div>
        </div>
    )
}
export default ReservationSource;